import styled from "styled-components";

export const StyledMyExplore = styled.div`
  text-align: center;
  display: grid;
  place-content: center;
  min-height: 100vh;
`;
